import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Drobne helpery UI.
 *
 * `cn` — składa klasy Tailwind (clsx: odfiltrowuje wartości fałszywe, obsługuje
 * tablice/obiekty) i rozwiązuje konflikty utility przez `tailwind-merge` — przy
 * nadpisaniu tej samej właściwości (np. dwa `px-*`, dwa `bg-*`) wygrywa ostatnia,
 * deterministycznie, niezależnie od kolejności w arkuszu. Wymagane przez cva.
 *
 *   cn('base', active && 'is-active', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
